const LOCATIONS = {
  brookville_pa: 'Brookville, PA',
  northfork_wv: 'Northfork, WV',
};

export default { LOCATIONS };
